import { Link } from "react-router-dom";
import { route } from "../../../shim/jsbridge";

const HeaderAlertsEmpty = ({
  shouldConfigure,
  onLinkClick,
  reloadDocument
}: {
  shouldConfigure: boolean;
  onLinkClick: () => void;
  reloadDocument?: boolean;
}) => (
  <div
    className="header-alerts__list-item header-alerts__list-item--empty-list"
    data-testid="header_alerts_empty_list_message"
  >
    No Alerts Available.
    {shouldConfigure && (
      <div className="mt-5">
        <Link
          to={`${route("user_profile_section", {
            section: "alerts_configuration"
          })}`}
          onClick={onLinkClick}
          reloadDocument={reloadDocument}
        >
          Configure Alerts
        </Link>
      </div>
    )}
  </div>
);

export default HeaderAlertsEmpty;
